import Sidebar from "../../components/sidebar/Sidebar";
import Topbar from "../../components/topbar/Topbar";
import { useEffect, useState } from "react";
import Loader from "../../components/loader/Loader";
import Alerta from "../../components/alerta/Alerta";
import style from "./Certificados.module.css";
import TurmaApi from "../../services/TurmaApi";
import DocumentoApi from '../../services/DocumentosApi';
import Paginacao from "../../components/paginacao/Paginacao";
import { MdDelete, MdEdit, MdSearch, MdClose } from "react-icons/md";
import { Button, Form, Modal } from "react-bootstrap";
import BotaoNovo from "../../components/botaoNovo/BotaoNovo";
import { Link } from "react-router-dom";
import { FaFileDownload } from "react-icons/fa";
import BotaoComLoading from "../../components/loadingBotoes/LoadingBotoes";
import { useIsMobile } from "../../components/useIsMobile/UseIsMobile";

function Frequencia() {
    const isMobile = useIsMobile();
    const [menuHamburguerAberto, setMenuHamburguerAberto] = useState(!isMobile);

    useEffect(() => {
        setMenuHamburguerAberto(!isMobile);
    }, [isMobile]);

    //Modais para adicionar, deletar e ver
    const [mostrarModalDeletar, setMostrarModalDeletar] = useState(false);
    const [mostrarModalAdicionar, setMostrarModalAdicionar] = useState(false);
    const [certificadoSelecionado, setCertificadoSelecionado] = useState(null);

    //Para exibir o alerta
    const [mostrarAlerta, setMostrarAlerta] = useState(false);
    const [mensagemAlerta, setMensagemAlerta] = useState("");
    const [tipoAlerta, setTipoAlerta] = useState("");
    const [loading, setLoading] = useState(false);

    //Para rodar a tabela, paginação e filtro
    const [certificados, setCertificados] = useState([]);
    const [quantidadeItens, setQuantidadeItens] = useState();
    const [turma, setTurma] = useState(0);
    const [tipo, setTipo] = useState(0);
    const [turmaFiltro, setTurmaFiltro] = useState(0);
    const [tipoFiltro, setTipoFiltro] = useState(0);
    const [paginaAtual, setPaginaAtual] = useState(1);

    const [tiposCertificados, setTiposCertificados] = useState([]);
    const [turmas, setTurmas] = useState([]);

    //Para emitir um novo certificado
    const [tipoAdicionar, setTipoAdicionar] = useState(0);
    const [turmaAdicionar, setTurmaAdicionar] = useState(0);
    const [horasAdicionar, setHorasAdicionar] = useState(0);
    const [nomeAdicionar, setNomeAdicionar] = useState("");
    const [pessoaIdAdicionar, setPessoaIdAdicionar] = useState(0);
    const [alunos, setAlunos] = useState([]);

    //Função para filtro de busca
    async function BuscarCertificados() {
        setTurma(turmaFiltro);
        setTipo(tipoFiltro);
        setPaginaAtual(1);
        await CarregarCertificados();
    }

    //Função para resetar  filtro de busca
    async function ResetarCertificados() {
        setTurma(0);
        setTipo(0);
        setTipoFiltro(0);
        setTurmaFiltro(0);
        setPaginaAtual(1);
        await CarregarCertificados();
    }

    //Função para abrir o modal de deletar
    const AbrirModalDeletar = (certificado) => {
        setLoading(true);
        setCertificadoSelecionado(certificado);
        setMostrarModalDeletar(true);
        setLoading(false);
    };

    //Função para abrir o modal de adicionar
    const AbrirModalAdicionar = () => {
        setLoading(true);
        setMostrarModalAdicionar(true);
        setLoading(false);
    };

    //Função para o fechar modal
    const FecharModal = () => {
        setMostrarModalDeletar(false);
        setMostrarModalAdicionar(false);
        setCertificadoSelecionado(null);
        setTipoAdicionar(0);
        setTurmaAdicionar(0);
        setHorasAdicionar(0);
        setPessoaIdAdicionar(0);
        setAlunos([]);
        setNomeAdicionar("");
    };

    //Função para alterar a página
    async function AlterarPagina(paginaNova) {
        setPaginaAtual(paginaNova);
        await CarregarCertificados();
    }

    //Função para listar os certificados
    async function CarregarCertificados() {
        try {
            const listaCertificados = await DocumentoApi.ObterCertificadosPorPaginacao(
                paginaAtual,
                tipo,
                turma
            );
            setQuantidadeItens(listaCertificados.quantidadeRegistros);
            setCertificados(listaCertificados.registros);
        } catch (error) {
            console.error("Erro ao carregar certificados:");
        }
    }

    async function BuscarTurmas() {
        try {
            var listaTurmas = await TurmaApi.ListarTurmaSemPaginacaoAsync();
            setTurmas(listaTurmas);
        } catch (error) {
            console.error("Erro ao buscar turmas.");
        }
    }

    async function BuscarTiposDocumentos() {
        try {
            var listaTipos = await DocumentoApi.ListarTipoEnum();
            setTiposCertificados(listaTipos);
        } catch (error) {
            console.error("Erro ao buscar os tipos de documentos.");
        }
    }

    const ObterAlunosSemCertificados = async (tipo, idTurma) => {
        try {
            var listaAlunos = await DocumentoApi.ObterAlunosSemCertificado(tipo, idTurma);
            setAlunos(listaAlunos);
        } catch (error) {
            console.error("Erro ao buscar alunos.");
        }
    }

    const BaixarDocumento = async (doc) => {
        try {
            setLoading(true);
            const response = await DocumentoApi.BaixarDocumento(doc);

            const blob = new Blob([response.data], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `${doc.titulo || "documento"}.pdf`);
            document.body.appendChild(link);
            link.click();
            link.remove();

            setMensagemAlerta("Certificado baixado com sucesso!");
            setTipoAlerta("success");
            exibirAlerta(true);

        } catch (error) {
            setMensagemAlerta(`Erro ao baixar o documento`);
            setTipoAlerta("danger");
            exibirAlerta(true)
        } finally {
            setLoading(false);
        }
    };

    //Função para adicionar
    const EmitirCertificado = async () => {
        try {
            if (tipoAdicionar === 3) {
                setLoading(true);
                await DocumentoApi.EmitirCertificadoConclusao(pessoaIdAdicionar, nomeAdicionar);
                CarregarCertificados();
                setMensagemAlerta(`Emissão de certificado realizada com sucesso!`);
                setTipoAlerta("success");
                exibirAlerta(true);
            }
            else if (tipoAdicionar === 4) {
                setLoading(true);
                await DocumentoApi.EmitirCertificadoMonitoria(pessoaIdAdicionar, horasAdicionar, nomeAdicionar);
                CarregarCertificados();
                setMensagemAlerta(`Emissão de certificado realizada com sucesso!`);
                setTipoAlerta("success");
                exibirAlerta(true);
            } else {
                setMensagemAlerta(`Não é possivel emitir o certificado`);
                setTipoAlerta("danger");
                exibirAlerta(true);
            }
        } catch (error) {
            setMensagemAlerta(`Erro ao emitir certificado`);
            setTipoAlerta("danger");
            exibirAlerta(true);
        } finally {
            FecharModal();
            setLoading(false);
        }
    };

    async function DeletarDocumento() {
        try {
            setLoading(true);
            await DocumentoApi.RemoverDocumento(certificadoSelecionado.documentoID)
            setMensagemAlerta("Documento deletado com sucesso!");
            setTipoAlerta("success");
            exibirAlerta(true);
            CarregarCertificados();
            FecharModal();
        } catch (error) {
            setMensagemAlerta("Erro ao deletar o Documento!");
            setTipoAlerta("danger");
            exibirAlerta(true);
        } finally {
            setLoading(false);
        }
    }

    function ExibirNomeCertificado(statusTipoArquivo, tiposCertificados) {
        const tipo = tiposCertificados.find(t => t.id === statusTipoArquivo);

        if (!tipo) return 'Desconhecido';

        switch (tipo.nome) {
            case 'ArquivoCertificadoMonitoria':
                return 'Monitoria';
            case 'ArquivoCertificadoCoclusao':
                return 'Conclusão';
            default:
                return tipo.nome;
        }

    }

    function ExibirNomeCertificadoDrop(tiposCertificados) {
        return tiposCertificados
            .filter((tipo) => tipo.id !== 1 && tipo.id !== 2)
            .map((tipo) => {
                let novoNome = tipo.nome;

                switch (tipo.nome) {
                    case 'ArquivoCertificadoMonitoria':
                        novoNome = 'Monitoria';
                        break;
                    case 'ArquivoCertificadoCoclusao':
                        novoNome = 'Conclusão';
                        break;
                }

                return {
                    id: tipo.id,
                    nome: novoNome
                };
            });
    }

    const totalPaginas = Math.ceil(quantidadeItens / 10); //total de paginas com itens filtrados

    //Função para exibir o alerta
    const exibirAlerta = () => {
        setMostrarAlerta(true);
        setTimeout(() => {
            setMostrarAlerta(false);
        }, 10000);
    };

    useEffect(() => {
        BuscarTurmas();
        BuscarTiposDocumentos();
    }, []);

    useEffect(() => {
        CarregarCertificados();
    }, [paginaAtual, tipo, turma]);

    return (
        <Sidebar menuHamburguerAberto={menuHamburguerAberto} setMenuHamburguerAberto={setMenuHamburguerAberto}>
            <Topbar
                menuHamburguerAberto={menuHamburguerAberto}
                setMenuHamburguerAberto={setMenuHamburguerAberto}
            >
                <Alerta
                    tipo={tipoAlerta}
                    mensagem={mensagemAlerta}
                    visivel={mostrarAlerta}
                    aoFechar={() => setMostrarAlerta(false)}
                />
                {loading && <Loader />}
                <div className={style.pagina_conteudo}>
                    <div className={style.container_cabecalho}>
                        <h4>Certificados</h4>
                        <BotaoNovo link={AbrirModalAdicionar} />
                    </div>
                    {/* Filtro de pesquisa */}
                    <div className={style.container_filtro}>
                        <Form.Select
                            id="hidenTipo"
                            name="Tipo"
                            value={tipoFiltro}
                            onChange={(e) => setTipoFiltro(e.target.value)}
                        >
                            <option value="">Tipo de certificado</option>
                            {ExibirNomeCertificadoDrop(tiposCertificados).map((tipo) => (
                                <option key={tipo.id} value={tipo.id}>
                                    {tipo.nome}
                                </option>
                            ))}
                        </Form.Select>

                        <Form.Select
                            id="hidenTurma"
                            name="Turma"
                            value={turmaFiltro}
                            onChange={(e) => setTurmaFiltro(e.target.value)}
                        >
                            <option value="">Turmas</option>
                            {turmas
                                .map((turma) => (
                                    <option key={turma.id} value={turma.id}>
                                        {turma.nome}
                                    </option>
                                ))}
                        </Form.Select>
                        <div className={style.container_filtro2} >
                            <Button onClick={BuscarCertificados} id={style.botao_buscar}>
                                <MdSearch /> Buscar
                            </Button>

                            <Button onClick={ResetarCertificados} id={style.botao_resetar}>
                                <MdClose /> Limpar
                            </Button>
                        </div>

                    </div>

                    {/* Tabela com paginação */}
                    <div className={style.container_tabela_paginacao}>
                        <div className={style.tabela_responsiva}>
                            <table className={style.container_tabela}>
                                <thead>
                                    <tr>
                                        <th>Nome Completo</th>
                                        <th>Certificado</th>
                                        <th>Data de Emissão</th>
                                        <th className={style.coluna_acoes}>Ações</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {certificados.map((certificado) => (
                                        <tr className={style.tabela_corpo} key={certificado.documentoID}>
                                            <td title={certificado.nomeCompleto}>{certificado.nomeCompleto}</td>
                                            <td
                                                title={ExibirNomeCertificado(certificado.statusTipoArquivo, tiposCertificados)}
                                            >
                                                {ExibirNomeCertificado(certificado.statusTipoArquivo, tiposCertificados)}
                                            </td>

                                            <td title={new Date(certificado.dataEnvio).toLocaleString("pt-BR")}>{new Date(certificado.dataEnvio).toLocaleString("pt-BR")}</td>

                                            <td className={style.coluna_acoes}>
                                                <Link
                                                    className={style.botao_baixar}
                                                    title="Baixar"
                                                    onClick={() => BaixarDocumento(certificado.documentoID)}
                                                >
                                                    <FaFileDownload />
                                                </Link>
                                                <Link
                                                    className={style.botao_deletar}
                                                    title="Deletar"
                                                    onClick={() => AbrirModalDeletar(certificado)}
                                                >
                                                    <MdDelete />
                                                </Link>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                        {/* Controle de Paginação */}
                        <Paginacao
                            id={style.configuracao_paginacao}
                            paginaAtual={paginaAtual}
                            totalPages={totalPaginas}
                            onPageChange={(novaPagina) => AlterarPagina(novaPagina)}
                        />
                    </div>
                </div>
                {/* Modal de confirmação para deletar */}
                <Modal show={mostrarModalDeletar} onHide={FecharModal}>
                    <Modal.Header closeButton>
                        <Modal.Title>Confirmar</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        Tem certeza que deseja deletar o certificado de <strong>{certificadoSelecionado?.nomeCompleto}</strong> ?
                    </Modal.Body>

                    <Modal.Footer>
                        <Button variant="secondary" onClick={FecharModal} disabled={loading}>
                            Cancelar
                        </Button>
                        <BotaoComLoading variant="danger" onClick={DeletarDocumento} disabled={loading}>
                            Deletar
                        </BotaoComLoading>
                    </Modal.Footer>
                </Modal>

                {/* Modal de adicionar suporte */}
                <Modal show={mostrarModalAdicionar} onHide={FecharModal}>
                    <Modal.Header closeButton>
                        <Modal.Title>Emitir certificado</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <Form.Label>Tipo de certificado</Form.Label>
                        <Form.Select
                            as="select"
                            name="Tipo"
                            value={tipoAdicionar}
                            onChange={(e) => {
                                const id = e.target.value;
                                setTipoAdicionar(Number(id));

                                if (turmaAdicionar && id) {
                                    ObterAlunosSemCertificados(id, turmaAdicionar);
                                }
                            }}
                            required
                        >
                            <option value="">Selecione o certificado</option>
                            {ExibirNomeCertificadoDrop(tiposCertificados).map((tipo) => (
                                <option key={tipo.id} value={tipo.id}>
                                    {tipo.nome}
                                </option>
                            ))}
                        </Form.Select>

                        <Form.Label>Turma</Form.Label>
                        <Form.Select
                            id="hidenTurma"
                            name="Turma"
                            value={turmaAdicionar}
                            onChange={(e) => {
                                const id = e.target.value;
                                setTurmaAdicionar(Number(id));

                                if (tipoAdicionar && id) {
                                    ObterAlunosSemCertificados(tipoAdicionar, id);
                                }
                            }}
                        >
                            <option value="">Selecione a turma</option>
                            {turmas
                                .map((turma) => (
                                    <option key={turma.id} value={turma.id}>
                                        {turma.nome}
                                    </option>
                                ))}
                        </Form.Select>

                        {turmaAdicionar !== 0 && tipoAdicionar !== 0 &&
                            <div>
                                <div>
                                    <Form.Label>Alunos</Form.Label>
                                    <Form.Select
                                        id="hidenAluno"
                                        name="Aluno"
                                        value={pessoaIdAdicionar}
                                        onChange={(e) => setPessoaIdAdicionar(e.target.value)}
                                        disabled={!turmaAdicionar && !tipoAdicionar}
                                    >
                                        <option value="">Selecione o aluno</option>
                                        {alunos
                                            .map((aluno) => (
                                                <option key={aluno.pessoaID} value={aluno.pessoaID}>
                                                    {aluno.nomeCompleto}
                                                </option>
                                            ))}
                                    </Form.Select>

                                    <Form.Group controlId="formCurso" className="mb-3">
                                        <Form.Label>Nome do curso</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="nomeCurso"
                                            value={nomeAdicionar}
                                            onChange={(e) => setNomeAdicionar(e.target.value)}
                                            placeholder="Digite o nome do curso"
                                            required
                                        />
                                    </Form.Group>
                                </div>
                                {tipoAdicionar === 4 &&
                                    <div>
                                        <Form.Group controlId="formHoras" className="mb-3">
                                            <Form.Label>Horas de monitoria</Form.Label>
                                            <Form.Control
                                                type="number"
                                                name="horas"
                                                value={horasAdicionar}
                                                onChange={(e) => setHorasAdicionar(e.target.value)}
                                                min={1}
                                                max={90}
                                                step={1}
                                                placeholder="Digite o número de horas"
                                                required
                                            />
                                        </Form.Group>
                                    </div>
                                }
                            </div>
                        }

                    </Modal.Body>

                    <Modal.Footer>
                        <Button variant="secondary " onClick={FecharModal} disabled={loading}>
                            Cancelar
                        </Button>
                        <Button variant="success" onClick={EmitirCertificado} disabled={loading}>
                            Adicionar
                        </Button>
                    </Modal.Footer>
                </Modal>
            </Topbar>
        </Sidebar >
    );
}

export default Frequencia;
